/**
 *
 * Onboarding
 *
 */

import React from "react"
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride"
import { find } from "lodash"
import handImage from "images/hand.jpg"
import stepOneImage from "images/onboarding/medition.svg"
import stepTwoImage from "images/onboarding/result.svg"
import stepThreImage from "images/onboarding/actionPlan.svg"
import ModalOnboarding from "../ModalOnboarding"
import { ROLE_AMBASSADOR } from "../../utils/constants"
import {
  KEY_ONBOARDING,
  LOCAL_ACTIVE_ROL,
  LOCAL_ONBOARDING,
  LOCAL_USER_NAME,
  setItem,
} from "../../utils/storage"
import { loadTexts, sanitize } from "../../utils/i18n"
import { CloseSquareOutlined } from "@ant-design/icons"

class Onboarding extends React.Component {
  state = {
    run: false,
    sections: [],
    currentSection: {},
    currentStep: {},
    currentIndex: 0,
    joy: false,
  }
  globalIntl = loadTexts("onboarding")
  step_administrator = [
    {
      section: "organization",
      steps: [
        {
          target: ".step-menu-organization",
          type: "modal",
          content: () => {
            return (
              <div className="modalOnboarding--center">
                <h1>¡Bienvenid@/ {LOCAL_USER_NAME().split(" ")[0]}!</h1>
                <h2>Diseñemos un mundo donde trabajar bien es posible</h2>
                <p>Síguenos en un breve tour de la plataforma...</p>
              </div>
            )
          },
          buttonStart: "¡Vamos!",
          image: handImage,
          imageWidth: 105,
        },
        {
          target: ".step-menu-organization",
          type: "modal",
          image: stepOneImage,
          content: () => {
            return (
              <div className="modalOnboarding--center">
                <h2 className="modalOnboarding__title--h2">
                  Realiza mediciones de manera simple
                </h2>
                <p>
                  Crea encuestas de Clima Laboral y Engagement{" "}
                  <b>personalizadas</b> para tu organización <br />y agenda{" "}
                  <b>mediciones</b> que te permitan detectar fortalezas y
                  oportunidades de mejora en <b>tiempo real</b>.
                </p>
              </div>
            )
          },
          buttonsStep: true,
        },
        {
          target: ".step-menu-organization",
          type: "modal",
          content: () => {
            return (
              <div className="modalOnboarding--center">
                <h2 className="modalOnboarding__title--h2">
                  Visualiza tus resultados de forma automática
                </h2>
                <p>
                  Visualiza los <b>resultados</b> de tus mediciones continuamente
                  y realiza análisis <b>comparativos</b> jugando con las distintas
                  variables. Además, <b>exporta</b> los resultados en el formato
                  que prefieras.
                </p>
              </div>
            )
          },
          image: stepTwoImage,
          buttonsStep: true,
        },
        {
          target: ".step-menu-organization",
          type: "modal",
          content: () => {
            return (
              <div className="modalOnboarding--center">
                <h2 className="modalOnboarding__title--h2">
                  Acciona sobre tus indicadores
                </h2>
                <p>
                  Empodera a los <b>líderes</b> de tu organización asignándolos
                  como <b>embajadores</b> del Clima Laboral y Engagement, e
                  ideando conjuntamente <b>planes de acción</b> que les permitan
                  mejorar sus resultados.
                </p>
              </div>
            )
          },
          image: stepThreImage,
          buttonsStep: true,
          nextButton: "¡Genial!",
        },
        {
          target: ".step-menu-organization",
          type: "step",
          content: (
            <div>
              Desde <b>Organización</b> podrás administrar las Divisiones (áreas)
              y Colaboradores dentro de tu empresa.
            </div>
          ),
          disableBeacon: true,
          placement: "left-start",
          offset: 4,
        },
      ],
    },
    {
      section:"pda-evidence",
      steps:[
        {
          target:  ".stepEvidence-10",
          disableBeacon: true,
          type:"step",
          spotlightClicks: false, // evita que se ilumine
          styles: {
            spotlight: {
              display: "none", // 
          }
        },
          content: (
            <div>
              <h2 style={{color:"#FFFFFF",fontSize:16,fontWeight:600}}>{this.globalIntl.evidence.titleOnboarding}</h2>
              <p style={{color:"#FFFFFF",fontSize:13}}>
              {this.globalIntl.evidence.descriptionOnboarding1sub1}</p>
              <p style={{color:"#FFFFFF",fontSize:13}}>
              {this.globalIntl.evidence.descriptionOnboarding1sub2}</p>
            </div>
            
           
          ),
          placement: "left",
        },
        {
          target:  ".stepEvidence-20",
          disableBeacon: true,
          type:"step",
          spotlightClicks: false, // evita que se ilumine
          styles: {
            spotlight: {
              display: "none", // 
          }
        },
          content: (
            <div>
              <h2 style={{color:"#FFFFFF",fontSize:16,fontWeight:600}}>{this.globalIntl.evidence.descriptionOnboarding1sub3}</h2>
              <p style={{color:"#FFFFFF",fontSize:13}}>
              {this.globalIntl.evidence.descriptionOnboarding1sub4}</p>
            </div>
            
           
          ),
          placement: "right",
        },

      ]
    },
    {
      section:"pda-evidence-edit",
      steps:[
        {
          target:  ".content-evidence",
          disableBeacon: true,
          type:"step",
          spotlightClicks: false, // evita que se ilumine
          styles: {
            spotlight: {
              display: "none", // 
          }
        },
          content: (
            <div>
              <h2 style={{color:"#FFFFFF",fontSize:16,fontWeight:600}}>{this.globalIntl.evidence.titleOnboarding}</h2>
              <p style={{color:"#FFFFFF",fontSize:13}}>
              {this.globalIntl.evidence.descriptionOnboarding2sub1}</p>
            </div>
            
           
          ),
          placement: "left",
        },

      ]
    }
  ]
 
  step_ambassador = [
    {
      section: "dashboard",
      steps: [
        {
          target: ".step-menu-dashboard",
          type: "modal",
          content: () => {
            return (
              <div className="modalOnboarding--center">
                <h1>
                  {this.globalIntl.ambassador.step1.title}{" "}
                  {LOCAL_USER_NAME().split(" ")[0]}!
                </h1>
                <h2>{this.globalIntl.ambassador.step1.subtitle}</h2>
                <p>{this.globalIntl.ambassador.step1.description}</p>
              </div>
            )
          },
          buttonStart: this.globalIntl.ambassador.step1.button,
          image: handImage,
          imageWidth: 105,
        },
        {
          target: ".step-menu-dashboard",
          type: "modal",
          content: () => {
            return (
              <div className="modalOnboarding--center">
                <h2>{this.globalIntl.ambassador.step2.title}</h2>
                <p>{sanitize(this.globalIntl.ambassador.step2.description)}</p>
              </div>
            )
          },
          image: stepTwoImage,
          buttonsStep: true,
        },
        {
          target: ".step-menu-dashboard",
          type: "modal",
          content: () => {
            return (
              <div className="modalOnboarding--center">
                <h2>{this.globalIntl.ambassador.step3.title}</h2>
                <p>{sanitize(this.globalIntl.ambassador.step3.description)}</p>
              </div>
            )
          },
          image: stepThreImage,
          buttonsStep: true,
          nextButton: this.globalIntl.ambassador.step3.nextButton,
          placement: "left-start",
          offset: 4,
        },
        {
          target: ".step-menu-dashboard",
          type: "step",
          content: <div>{sanitize(this.globalIntl.ambassador.step4.description)}</div>,
          disableBeacon: true,
          placement: "left-start",
          offset: 4,
        },
        {
          target: ".step-menu-reports",
          type: "step",
          content: <div>{sanitize(this.globalIntl.ambassador.step5.description)}</div>,
          disableBeacon: true,
          placement: "left-start",
          offset: 4,
        },
        {
          target: ".step-menu-help-center",
          type: "step",
          content: <div>{sanitize(this.globalIntl.ambassador.step6.description)}</div>,
          disableBeacon: true,
          placement: "bottom-end",
          offset: 4,
        },
        {
          target: ".step-menu-profile",
          type: "step",
          content: <div>{sanitize(this.globalIntl.ambassador.step7.description)}</div>,
          disableBeacon: true,
          placement: "bottom-end",
          offset: 4,
        },
      ],
    },
    {
      section:"pda-evidence",
      steps:[
        {
          target:  ".stepEvidence-10",
          disableBeacon: true,
          type:"step",
          spotlightClicks: false, // evita que se ilumine
          styles: {
            spotlight: {
              display: "none", // 
          }
        },
          content: (
            <div>
              <h2 style={{color:"#FFFFFF",fontSize:16,fontWeight:600}}>{this.globalIntl.evidence.titleOnboarding}</h2>
              <p style={{color:"#FFFFFF",fontSize:13}}>
              {this.globalIntl.evidence.descriptionOnboarding1sub1}</p>
              <p style={{color:"#FFFFFF",fontSize:13}}>
              {this.globalIntl.evidence.descriptionOnboarding1sub2}</p>
            </div>
            
           
          ),
          placement: "left",
        },
        {
          target:  ".stepEvidence-20",
          disableBeacon: true,
          type:"step",
          spotlightClicks: false, // evita que se ilumine
          styles: {
            spotlight: {
              display: "none", // 
          }
        },
          content: (
            <div>
              <h2 style={{color:"#FFFFFF",fontSize:16,fontWeight:600}}>{this.globalIntl.evidence.descriptionOnboarding1sub3}</h2>
              <p style={{color:"#FFFFFF",fontSize:13}}>
              {this.globalIntl.evidence.descriptionOnboarding1sub4}</p>
            </div>
            
           
          ),
          placement: "right",
        },

      ]
    },
    {
      section:"pda-evidence-edit",
      steps:[
        {
          target:  ".content-evidence",
          disableBeacon: true,
          type:"step",
          spotlightClicks: false, // evita que se ilumine
          styles: {
            spotlight: {
              display: "none", // 
          }
        },
          content: (
            <div>
              <h2 style={{color:"#FFFFFF",fontSize:16,fontWeight:600}}>{this.globalIntl.evidence.titleOnboarding}</h2>
              <p style={{color:"#FFFFFF",fontSize:13}}>
              {this.globalIntl.evidence.descriptionOnboarding2sub1}</p>
            </div>
            
           
          ),
          placement: "left",
        },

      ]
    }
  ]

  UNSAFE_componentWillMount = () => {
    this.setState(
      {
        sections:
          LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR
            ? this.step_ambassador
            : this.step_administrator,
      },
      () => {
        this.init()
      }
    )
  }

  handleJoyrideCallback = (data) => {
    const { action, index, status, type,step } = data
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState(
        { currentIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
        () => this.updateStep()
      )
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      this.setState({ joy: false, run: false })
    }
    if (type === "step:before" && (step.target === ".content-evidence" || this.props.section === "pda-evidence-edit")) {
      document.querySelector(".content-evidence")?.scrollIntoView({
        behavior: "smooth",
        block: "center", 
      });
    }
    
  }

  updateStepServer = (data) => {
    const { section } = this.props
    const { currentIndex } = this.state
    const current = LOCAL_ONBOARDING() ? JSON.parse(LOCAL_ONBOARDING()) : []
    const sendData = {
      section,
      step: currentIndex + 1,
    }
    fetchGlobalApi({
      method: "POST",
      endpoint: "onboarding/update",
      data: { data: sendData },
    })

    const findIndex = current.findIndex((e) => e.section === section)
    if (findIndex > -1) {
      current[findIndex].step = currentIndex + 1
    } else {
      current.push({
        section,
        step: currentIndex + 1,
      })
    }
    setItem(KEY_ONBOARDING, JSON.stringify(current))
  }

  init = () => {
    
    if (LOCAL_ONBOARDING() == "false") return false
    const current = JSON.parse(LOCAL_ONBOARDING())
    const { section } = this.props
    const search = find(current, { section }) // busca en que paso estás
    const searchSection = find(this.state.sections, { section }) // obtiene los pasos de la sección actual
    const currentIndex = (search ? search.step : 1) - 1
    const currentStep = searchSection.steps[currentIndex] // Obtener el primer paso para iniciar en caso no esté iniciado
   
    if (currentStep) {
      return this.setState({
        currentStep,
        joy: currentStep.type === "step",
        run: currentStep.type === "modal",
        currentSection: searchSection,
        currentIndex,
      })
    }
  }

  updateStep = () => {
    const { currentIndex } = this.state
    const { section } = this.props
    const searchSection = find(this.state.sections, { section })
    const currentStep = searchSection.steps[currentIndex]
    if (currentStep) {
      this.updateStepServer()
      return this.setState({
        currentStep,
        joy: currentStep.type === "step",
        run: currentStep.type === "modal",
      })
    }
    this.updateStepServer()
    return this.setState({
      joy: false,
      run: false,
    })
  }

  modalNext = (back = false) => {
    const { currentIndex } = this.state
    const { section } = this.props
    const searchSection = find(this.state.sections, { section })
    const newIndex = back ? currentIndex - 1 : currentIndex + 1
    if (searchSection.steps[newIndex]) {
      this.setState({ currentIndex: newIndex }, () => this.updateStep())
    }
  }
  componentDidMount() {
    window.addEventListener("joyride-close", this.forceClose);
  }
  
  componentWillUnmount() {
    window.removeEventListener("joyride-close", this.forceClose);
  }
  forceClose = () => {
    this.setState({ joy: false, run: false });
  };
  
  render() {
    const { run, currentStep, currentSection, currentIndex, joy } = this.state
    const CustomTooltip = ({
      continuous,
      index,
      step,
      backProps,
      closeProps,
      primaryProps,
      tooltipProps,
      size,
        }) => {
          const handleClose = (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (closeProps?.onClick) {
              closeProps.onClick(e);
            }
            if (typeof window !== "undefined" && window.dispatchEvent) {
              window.dispatchEvent(new CustomEvent("joyride-close"));
            }
          };
          return (
            <div
              {...tooltipProps}
              style={{
                backgroundColor: "#2C5BFF",
                fontSize: 15,
                width: 420,
                color: "#FFFFFF",
                padding: "16px",
                position: "relative",
              }}
            >
              {/* Contenido */}
              <div style={{ marginBottom: 20 }}>{step.content}</div>
        
              {/* Footer */}
              <div
                style={{
                  marginTop: 8,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/* Izquierda: cerrar + progreso */}
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    color: "#FFFFFF",
                    fontWeight: 600,
                    cursor: "pointer",
                    border: "none",
                    fontSize: 13,
                  }}
                >
                    <CloseSquareOutlined /> {this.globalIntl.generalButtons.closeButton}
                  </button>
                  <span style={{ fontWeight: "bold" }}>•</span>
                  <span style={{ fontSize: 13, fontWeight: 600,color: "#FFFFFF" }}>
                    {index + 1} {this.globalIntl.generalButtons.of} {size}
                  </span>
                </div>
        
                {/* Derecha: siguiente */}
                <button
                  {...primaryProps}
                  onClick={(e) => {
                    primaryProps.onClick(e);
                    if (!continuous || index + 1 === size) {
                      if (typeof window !== "undefined" && window.dispatchEvent) {
                      window.dispatchEvent(new CustomEvent("joyride-close"));
                      }
                    }
                    }}
                  style={{
                    fontSize: 14,
                    backgroundColor: "#FFFFFF",
                    color: "#2C5BFF",
                    border: "none",
                    outline: "none",
                    borderRadius: 6,
                    padding: "6px 12px",
                    cursor: "pointer",
                  }}
                >
                  {continuous && index + 1 < size ? this.globalIntl.generalButtons.nextButton : this.globalIntl.generalButtons.finishButton}
                </button>
              </div>
            </div>
          )
        }
    
    const CustomTooltipEdit = ({
      step,
      closeProps,
      tooltipProps,
    }) => {
      const handleClose = (e) => {
        e.preventDefault();
        e.stopPropagation();
    
        if (closeProps?.onClick) {
          closeProps.onClick(e);
        }
        if (typeof window !== "undefined" && window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent("joyride-close"));
        }
      };
    
      return (
        <div
          {...tooltipProps}
          style={{
            backgroundColor: "#2C5BFF",
            fontSize: 15,
            width: 420,
            color: "#FFFFFF",
            padding: "16px",
            position: "relative",
          }}
        >
          {/* Contenido */}
          <div style={{ marginBottom: 20 }}>{step.content}</div>
    
          {/* Solo botón cerrar */}
          <div
            style={{
              marginTop: 8,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <button
              onClick={handleClose}
              style={{
                background: "transparent",
                color: "#FFFFFF",
                fontWeight: 600,
                cursor: "pointer",
                border: "none",
                fontSize: 13,
              }}
            >
              <CloseSquareOutlined /> {this.globalIntl.generalButtons.closeButton}
            </button>
          </div>
        </div>
      );
    };
    if(joy && currentStep.type === "step" && this.props.section === "pda-evidence-edit"){
      document.querySelector(".content-evidence").scrollIntoView({
        behavior: "smooth", 
        block: "start"     
      });   
    }
    
    return (
      <React.Fragment>
        <ModalOnboarding
          width={730}
          currentIndex={currentIndex}
          totalStep={
            currentSection.steps &&
            currentSection.steps.filter((e) => e.type === "modal").length
          }
          nextButton={currentStep.nextButton}
          open={run && currentStep.type === "modal"}
          textAlign="left"
          onOk={() => {
            this.modalNext()
          }}
          onBack={() => {
            this.modalNext(true)
          }}
          onClose={() => this.setState({ run: false })}
          buttonsStep={currentStep.buttonsStep}
          buttonStart={currentStep.buttonStart}
          image={currentStep.image}
          imageWidth={currentStep.imageWidth}>
          <div>
            {typeof currentStep.content === "function" && currentStep.content()}
          </div>
        </ModalOnboarding>

        <Joyride
          run={joy && currentStep.type === "step"}
          steps={currentSection.steps}
          showSkipButton={false}
          continuous
          callback={this.handleJoyrideCallback}
          floaterProps={{
            styles: {
              arrow: {
                length: 8,
                spread: 20,
                marginLeft: 0,
              },
            },
          }}
          styles={{
            options: {
              primaryColor: "#1890ff",
              zIndex: 1000,
              arrow: {
                color: "red",
                display: "inline-flex",
                length: 16,
                margin: 8,
                position: "absolute",
                spread: 32,
              },
            },
            buttonBack: {
              fontSize: 15,
              outline: 0,
            },
            buttonNext: {
              fontSize: 15,
              outline: 0,
            },
            tooltip: {
              fontSize: 15,
              width: 320,
            },
            tooltipContainer: { textAlign: "left" },
            tooltipContent: {
              padding: "10px 10px 0",
              lineHeight: "1.5",
            },
            buttonClose: {
              width: 8,
              height: 8,
            },
          }}
          locale={{
            back: this.globalIntl.generalButtons.backButton,
            close: this.globalIntl.generalButtons.closeButton,
            last: this.globalIntl.generalButtons.lastButton,
            next: this.globalIntl.generalButtons.nextButton,
            skip: this.globalIntl.generalButtons.skipButton,
          }}
          stepIndex={currentIndex}
          tooltipComponent={
            this.props.section === "pda-evidence"
              ? CustomTooltip
              : this.props.section === "pda-evidence-edit"
              ? CustomTooltipEdit
              : undefined
          }
          disableOverlayClose = {this.props.section === "pda-evidence" || this.props.section === "pda-evidence-edit" ? true : false}
          
          spotlightPadding={0}
        />

      </React.Fragment>
    )
  }
}

Onboarding.propTypes = {}

export default Onboarding
